import {InstrumentActionTypes} from '../../constants/actionType';

export const setEStopTriggered = (data) => ({
  type: InstrumentActionTypes.SET_ESTOP_TRIGGERED,
  data,
});

export function setIsSimulationMode(data) {
  return (dispatch) => {
    dispatch({type: InstrumentActionTypes.SET_IS_SIMULATION_MODE, data});
  };
}

export function setIsAutomationMode(data) {
  return (dispatch) => {
    dispatch({type: InstrumentActionTypes.SET_IS_AUTOMATION_MODE, data});
  };
}

export function setInstrumentServiceStatus(data) {
  return (dispatch) => {
    dispatch({type: InstrumentActionTypes.SET_INSTRUMENT_SERVICE_STATUS, data});
  };
}

export function setLabwareServiceStatus(data) {
  return (dispatch) => {
    dispatch({type: InstrumentActionTypes.SET_LABWARE_SERVICE_STATUS, data});
  };
}

export function setInstrumentStatus(data) {
  return (dispatch) => {
    dispatch({type: InstrumentActionTypes.SET_INSTRUMENT_STATUS, data});
  };
}
export function setMotorErrorData(data = {}) {
  return (dispatch) => {
    dispatch({type: InstrumentActionTypes.SET_MOTOR_ERROR_DATA, data});
  };
}
